import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { styled } from '@material-ui/core/styles';

const marks = [
  {
    value: 0,
    label: 'Progress.',
  },
    {
    value: 100,
    label: '% complete.',
  },
];

//const PrettoSlider = styled(Slider)({
//    height: 15,
//    width: "90%",
//    marginLeft: 20,
//    justify: "center",
//    '& .MuiSlider-thumb': {
//      height: 21,
//      width: 21,
//      backgroundColor: '#fff',
//      border: '2px solid currentColor',
//      marginTop: -9,
//      marginLeft: -9,
//      '&:focus, &:hover, &.Mui-active': {
//        boxShadow: 'inherit',
//      },
//    },
//    '& .MuiSlider-valueLabel': {
//      left: 'calc(-25% + 4px)',
//      scale: (0.01)
//    },
//    '& .MuiSlider-track': {
//      height: 15,
//      borderRadius: 4,
//      opacity: 0.01,
//      
//    },
//    '& .MuiSlider-rail': {
//      height: 15,
//      borderRadius: 4,
//      marginTop: -6,
//      marginLeft: -10,
//      backgroundColor: "#002D55"
//      width: "105%"
//    },
//  });

const PrettoSlider = withStyles({
  root: {
    color: '#FFA500', // orange
    height: 8,
    minHeight: 8,
    padding: '0 4px',
  },
  thumb: {
    display: 'none', // hide thumb
  },
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#FFA500', // orange
  },
  rail: {
    height: 8,
    borderRadius: 4,
    opacity: 0.7,
    backgroundColor: 'rgba(220,220,220,0.7)', // light grey, slightly transparent
  },
  mark: {
    display: 'none', // hide marks
  },
  markActive: {
    display: 'none', // hide active marks
  },
  valueLabel: {
    display: 'none', // hide value label
  },
})(Slider);

function valuetext(value) {
  return `{value} %`;
}

export default function DiscreteSlider(props) {
  const [sliderVal, setSliderVal] = useState(0);

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setSliderVal(props.value);
    }
  }, [props.value]);

  const handleChange = (event, value) => {
    setSliderVal(value);
    if (props.onChange) {
      props.onChange(event, value);
    }
  };

  // Determine bar color
  let barColor = '#FFA500'; // default orange
  if (props.barColor) {
    barColor = props.barColor;
  } else if (sliderVal > 90) {
    barColor = '#90ee90'; // light green
  }

  // Custom PrettoSlider with dynamic color
  const DynamicSlider = withStyles({
    root: {
      color: barColor,
      height: 8,
      minHeight: 8,
      padding: '0 4px',
    },
    thumb: {
      display: 'none',
    },
    track: {
      height: 8,
      borderRadius: 4,
      backgroundColor: barColor,
    },
    rail: {
      height: 8,
      borderRadius: 4,
      opacity: 0.7,
      backgroundColor: 'rgba(220,220,220,0.7)',
    },
    mark: {
      display: 'none',
    },
    markActive: {
      display: 'none',
    },
    valueLabel: {
      display: 'none',
    },
  })(Slider);

  return (
    <div style={{ position: 'relative' }}>
      <DynamicSlider
        defaultValue={0}
        step={1}
        value={sliderVal}
        onChange={handleChange}
        min={0}
        max={100}
      />
      {sliderVal > 90 && (
        <span style={{
          position: 'absolute',
          top: -5,
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#43a047',
          fontWeight: 'bold',
          fontSize: 15,
          background: '#e8f5e9',
          borderRadius: 8,
          padding: '2px 2px',
          boxShadow: '0 1px 4px rgba(67,160,71,0.10)'
        }}>
        </span>
      )}
    </div>
  );
}
